import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type PaginatedResults } from "shared/api/types/pagination";
import { type SocietyWorkflowParamsInput } from "shared/api/types/society/[societyId]/workflow/[workflowId]";
import { type WorkflowStateView } from "shared/mappers/database/workflow/workflow-state";
export const getSocietyWorkflowStateContract: BaseApiContract<
  SocietyWorkflowParamsInput,
  undefined,
  PaginatedResults<WorkflowStateView>
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/workflow/[workflowId]/state",
  paramsType: {} as SocietyWorkflowParamsInput,
  responseType: {} as PaginatedResults<WorkflowStateView>,
};
